import React, { Component, Fragment } from "react";
import MinCard from "../../Dashboard/MinCard";
import aggregacao from "../aggregacao";
import { parseLabelCampo } from "../../../../constants/metricas";

// Substitui o antigo widget "EP vs. Faculdade" (decisão do usuário,
// 2026-08-28): abre a métrica selecionada pelos 3 tipos de financiamento em
// vez de EP/Faculdade -- ver docs/PLANO_AJUSTES_UX.md.
export default class PorTipoFinanciamento extends Component {

    render() {
        let { linhas, campo, mes } = this.props;
        let somas = aggregacao.somaPorTipoFinanciamento(linhas || [], campo, mes);
        let legenda = mes ? `Referente a ${mes}` : "Referente ao ano inteiro";

        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <h5>Por tipo de financiamento — {parseLabelCampo(campo)}</h5>
                    </div>
                </div>
                <div className="row">
                    <MinCard tipo="Gratuidade Regimental" valor={somas.regimental} icone="nc-single-02" legenda={legenda} />
                    <MinCard tipo="Gratuidade Não-Regimental" valor={somas.nao_regimental} icone="nc-single-02" legenda={legenda} />
                    <MinCard tipo="Pago" valor={somas.pago} icone="nc-single-02" legenda={legenda} />
                    <MinCard tipo="Total" valor={somas.total} icone="nc-single-02" legenda={legenda} />
                </div>
            </Fragment>
        )
    }
}
